import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, reactive, computed } from 'vue'
import Modal from '@/hooks/modalType'
import { message } from '@dc-platform/dc-components'
import ModalForm from './components/ModalForm.vue'
import { timeZoneEnum } from './timeZoneEnum'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
// import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import { personTimeZoneList, personTimeZoneDel } from '@/api/common'
import type { PersonTimeZoneParams, PersonTimeZoneListItem } from '@/typings/api/overseasSales'


const __default__ = { name: 'DcCosOFbuTimeZoneSetting' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const tableRef = ref()
const queryForm = reactive<PersonTimeZoneParams>({})
const columns = computed(() => [
  { title: '员工名称', dataIndex: 'userName' },
  { title: '员工工号', dataIndex: 'employeeNo' },
  { title: '部门', dataIndex: 'deptName' },
  { title: '时区', dataIndex: 'timeZoneId', minWidth: 450, dicData: timeZoneEnum },
  { title: '操作人', dataIndex: 'operatorName' },
  { title: '操作时间', dataIndex: 'createTime', width: 190 },
  { title: '操作', dataIndex: 'action', width: 190, fixed: 'right' }
])

const getList = (queryForm: PersonTimeZoneParams, callBack: (res: any) => void) => {
  personTimeZoneList(queryForm).then((res) => {
    callBack(res)
  })
}
const handleQueryChange = (type: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}

// 新增/编辑员工时区弹窗
const modalFormRef = ref()
const handleChange = (rows?: PersonTimeZoneListItem) => {
  modalFormRef.value?.init(rows)
}
const handleDelete = (rows: PersonTimeZoneListItem) => {
  Modal.delete({
    content: '删除操作无法恢复，请谨慎操作',
    onOk() {
      personTimeZoneDel({ id: rows.id as number }).then(() => {
        message.success('删除成功')
        handleQueryChange('fetch')
      })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dc_layout_main, { "is-breadcrumb": true }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_cos_table, {
              serial: "",
              columns: columns.value,
              search: queryForm,
              "onUpdate:search": _cache[4] || (_cache[4] = ($event: any) => ((queryForm) = $event)),
              onFetch: getList,
              ref_key: "tableRef",
              ref: tableRef,
              tableId: "DcCosOFbuTimeZoneSetting"
            }, {
              search: _withCtx(() => [
                _createVNode(_component_a_form, { model: queryForm }, {
                  default: _withCtx(() => [
                    _createVNode(_component_dc_form_item, { label: "员工工号" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UserSelect, {
                          value: queryForm.employeeNo,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.employeeNo) = $event)),
                          allowClear: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "员工名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: queryForm.userName,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.userName) = $event)),
                          maxlength: 200,
                          allowClear: "",
                          placeholder: "请输入"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "部门" }, {
                      default: _withCtx(() => [
                        _createVNode(CustomerAreaCascader, {
                          type: "search",
                          appId: "cos_ofbu",
                          ids: queryForm.deptList,
                          "onUpdate:ids": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.deptList) = $event))
                        }, null, 8, ["ids"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              button: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  type: "primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (handleChange()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'ofbu_timeZone_add_btn']
                ])
              ]),
              bodyCell: _withCtx(({ column, record }) => [
                (column.dataIndex === 'action')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleChange(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("编辑")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'ofbu_clue_write_follow_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleDelete(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'ofbu_clue_del_btn']
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "search"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(ModalForm, {
      ref_key: "modalFormRef",
      ref: modalFormRef,
      onFetch: _cache[5] || (_cache[5] = ($event: any) => (handleQueryChange('fetch')))
    }, null, 512)
  ], 64))
}
}

})